// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_0-0";
export var footer = "_0-2";
export var infoSection = "_0-3";
export var infoSectionContainer = "_0-4";
export var infoSectionTitleRow = "_0-5";
export var itemDetails = "_0-6";
export var line = "_0-7";
export var lineItemImage = "_0-1";
export var lineItems = "_0-8";
export var modalContent = "_0-9";
export var multiLineInfo = "_0-a";
export var orderName = "_0-b";
export var strong = "_0-c";